import { render } from "./DatenschutzPage.vue?vue&type=template&id=5ac866cf&scoped=true"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js"

import "./DatenschutzPage.vue?vue&type=style&index=0&id=5ac866cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac866cf"]])

export default __exports__